import { Table } from "antd";
import React from "react";
import { useCollection } from "../../../hooks/useCollection";
import { FoilPopup } from "./FoilPopup";

export default function Foil() {
   const { loading, data } = useCollection("foil");
   const columns = [
      {
         title: "Color",
         dataIndex: "color",
      },
      {
         title: "Costs",
         dataIndex: "costs",
         align: "center",
         sorter: {
            compare: (a, b) => a.costs - b.costs,
         },
      },
      {
         render: (value) => <FoilPopup title={value.machine} costs={value.costs} id={value.id} />,
      },
   ];

   const onChange = (pagination, filters, sorter, extra) => {
      console.log("params", pagination, filters, sorter, extra);
   };

   return (
      <div>
         <Table columns={columns} size="small" loading={loading} dataSource={data} onChange={onChange} pagination={false} />
      </div>
   );
}
